import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';

interface RegistrationPrefillData {
    email: string;
    name: string;
}

@Injectable({
    providedIn: 'root',
})
export class RegistrationPrefillManager {
    private readonly prefill: WritableSignal<RegistrationPrefillData | null> = signal(null);

    public readonly prefillName: Signal<string | undefined> = computed((): string | undefined => this.prefill()?.name);
    public readonly prefillEmail: Signal<string | undefined> = computed((): string | undefined => this.prefill()?.email);

    public clear(): void {
        this.prefill.set(null);
    }

    public setPrefill(data: RegistrationPrefillData): void {
        this.prefill.set({ ...data });
    }
}